export default __webpack_public_path__ + "static/media/search-result.5cc3097e.jpg";